import React from 'react';
import './Services.css';

const servicesData = [
  { name: "Fotografía & Video", description: "Producimos contenido visual de alta calidad que captura la esencia de tu marca." },
  { name: "Páginas Web & SEO", description: "Creamos sitios web optimizados para convertir visitantes en clientes y posicionarte en Google." },
  { name: "Redes Sociales & Publicidad", description: "Gestionamos tus redes y creamos campañas publicitarias que generan resultados medibles." },
  { name: "Diseño Gráfico & Branding", description: "Construimos una identidad de marca sólida y atractiva que te diferencia de la competencia." },
  { name: "Google Business Profile", description: "Optimizamos tu perfil de Google para atraer más clientes locales y mejorar tu visibilidad." },
  { name: "CRM & Automatización", description: "Implementamos sistemas para gestionar clientes y automatizar procesos, ahorrándote tiempo." }
];

const Services = () => {
  return (
    <section id="services" className="services-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Nuestros Servicios</h2>
          <p className="lead text-muted">Soluciones integrales para llevar tu marca al siguiente nivel.</p>
        </div>
        <div className="row">
          {servicesData.map((service, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div className="service-card text-center p-4 h-100">
                <div className="icon-placeholder mb-3"></div>
                <h5 className="fw-bold">{service.name}</h5>
                <p className="text-muted small">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
